import { render, staticRenderFns } from "./FeaturedChallengeForWtEntityList.vue?vue&type=template&id=b9ba5000&scoped=true&lang=pug&"
import script from "./FeaturedChallengeForWtEntityList.vue?vue&type=script&lang=js&"
export * from "./FeaturedChallengeForWtEntityList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedChallengeForWtEntityList.vue?vue&type=style&index=0&id=b9ba5000&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba5000",
  null
  
)

export default component.exports